export enum ReleasesTabView {
  overview,
  detail,
}

export const RELEASE_ID_PARAM_KEY = "releaseId";

export const getArtistReleasesTabView = (searchParams: URLSearchParams) => {
  return searchParams.get(RELEASE_ID_PARAM_KEY)
    ? ReleasesTabView.detail
    : ReleasesTabView.overview;
};

export const getSelectedReleaseIdFromArtistReleaseTab = (
  searchParams: URLSearchParams,
) => {
  const releaseId = searchParams.get(RELEASE_ID_PARAM_KEY);
  return releaseId ? Number(releaseId) : null;
};
